<div class="trending-card" *ngIf="topicName">
  <div class="topic">
    <a [routerLink]="['/', slugify(topicName)]" (click)="scrollToTop()">{{
      topicName
    }}</a>
  </div>
  <h2>
    <a
      [routerLink]="['/', slugify(topicName), slugify(shortTitle), blogId]"
      (click)="scrollToTop()"
      >{{ heading }}</a
    >
  </h2>
  <div class="read-time">{{ readTime }}</div>
</div>
